<!--
  File : SignUp.vue
  Reference: materialdesignicons.com
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card class="ma-3 elevation-0" width="480">
        <v-toolbar class="elevation-0" color="white">
          <v-toolbar-title class="primary--text">{{title}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-row class="pl-3 pr-3 pt-3" v-if="!login || login.level == 10">
              <v-select prepend-icon="mdi-map-marker" v-model="studio" :items="studios" label="스튜디오" />
            </v-row>
            <v-row class="pl-3 pr-3" v-if="login">
              <v-select prepend-icon="mdi-wallet-membership" v-model="level" :items="levels" label="회원구분" />
            </v-row>
            <v-text-field
              id="email"
              prepend-icon="mdi-account"
              type="email"
              label="아이디 (3자이상)"
              @keyup.13.stop.prevent="next('password')"
              v-model="email"
              class="pb-0"
            />
            <v-text-field
              id="password"
              prepend-icon="mdi-lock"
              type="password"
              label="비밀번호 (6자이상)"
              @keyup.13.stop.prevent="next('confirm')"
              v-model="password"
              class="pt-0 pb-0"
            />
            <v-text-field
              id="confirm"
              prepend-icon="mdi-lock"
              type="password"
              label="비밀번호확인"
              @keyup.13.stop.prevent="next('name')"
              v-model="confirm"
              class="pt-0 pb-0"
            />
            <v-text-field
              id="name"
              prepend-icon="mdi-tag"
              type="name"
              label="성명 (2자이상)"
              @keyup.13.stop.prevent="next('mobile')"
              v-model="name"
              class="pt-0 pb-0"
            />
            <v-radio-group row v-model="sex" class="pt-0 pb-0">
              <v-icon>mdi-human-male-female</v-icon><span class="pl-3 pr-3">성별</span>
              <v-radio value=1 label="남" />
              <v-radio value=2 label="여" />
            </v-radio-group>
            <v-text-field
              id="birth"
              prepend-icon="mdi-cake-variant"
              type="date"
              label="생년월일"
              v-model="birth"
            />
            <v-text-field
              id="mobile"
              prepend-icon="mdi-cellphone"
              type="tel"
              label="휴대폰 번호 (필수)"
              @keyup.13.stop.prevent="next('address')"
              v-model="mobile"
              class="pt-0 pb-0"
            />
            <v-text-field
              id="address"
              prepend-icon="mdi-home"
              type="text"
              label="주소"
              v-model="address"
              class="pt-0"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-left" cols="6">
            <a v-if="login == null" @click="signin()">로그인</a>
          </v-col>
          <v-col class="text-right" cols="6">
            <v-btn v-if="login != null" color="normal" @click.prevent="cancel()" class="mr-3">취소</v-btn>
            <v-btn color="secondary" elevation="0" @click.prevent="signup()">확인</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      login: null,
      title: '회원 가입',
      studios: [],
      levels: [],
      studio: 0,
      level: 0,
      email: '',
      password: '',
      confirm: '',
      name: '',
      sex: 0,
      birth: '',
      mobile: '',
      address: ''
    }
  },

  props: {
    source: String,
  },

  methods: {
    next: function (type) {
      if (type == 'password' && this.email.trim().length >= 3) {
        document.getElementById('password').focus()
      }
      else if (type == 'confirm' && this.password.length >= 6) {
        document.getElementById('confirm').focus()
      }
      else if (type == 'name' && this.confirm == this.password) {
        document.getElementById('name').focus()
      }
      else if (type == 'mobile' && this.name.trim().length >= 2) {
        document.getElementById('mobile').focus()
      }
      else if (type == 'address' && this.mobile.length >= 10) {
        document.getElementById('address').focus()
      }
    },

    signup: function () {
      if (this.login && this.studio == 0) {
        this.studio = this.login.studio
      }
      if (this.studio == 0) {
        alert('스튜디오를 선택해주세요.')
        return
      }
      if (this.email.trim().length < 3) {
        document.getElementById('email').focus()
        return
      }
      if (this.password.length < 6) {
        document.getElementById('password').focus()
        return
      }
      if (this.confirm != this.password) {
        document.getElementById('confirm').focus()
        return
      }
      if (this.name.trim().length < 2) {
        document.getElementById('name').focus()
        return
      }
      if (this.mobile.length < 10) {
        document.getElementById('mobile').focus()
        return
      }
      let params = new URLSearchParams()
      params.append('email', this.email.trim())
      params.append('password', this.password)
      params.append('name', this.name.trim())
      params.append('sex', this.sex)
      params.append('birth', this.birth)
      params.append('mobile', this.mobile ? this.mobile : '')
      params.append('address', this.address ? this.address : '')
      params.append('studio', this.studio)
      params.append('level', this.level)
      axios.post('/api/user/signup', params, util.headers)
      .then(response => {
        if (response.data.error) {
          if (response.data.error == 'email') {
            alert('이미 사용중인 아이디입니다. 다른 아이디를 사용해주세요.')
            this.email = ''
            document.getElementById('email').focus()
          }
        }
        else if (this.login == null) {
          this.$router.push('/login')
        }
        else {
          this.$router.push('/user/list')
        }
      })
    },

    cancel: function () {
      this.$router.push('/user/list')
    },

    signin: function () {
      this.$router.push('/login')
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(localStorage.getItem('login'))
    }
    if (this.login) {
      if (this.login.level == 5) {
        this.title = '회원 추가'
        this.level = 0
      }
      if (this.login.level == 10) {
        this.title = '스튜디오 운영자 추가'
        this.level = 5
      }
    }
    this.$emit('login', this.login)

    util.getStudios((studios, error) => {
      if (error) console.log(error)
      this.studios = studios
      this.studios.shift()
    })

    util.getLevels((levels, error) => {
      if (error) console.log(error)
      this.levels = levels
    })
  }
}
</script>

<style scoped>
</style>
